export const STORAGE_LAST_CLICKED_PRODUCT = "prv_cl_prdct";
export const STORAGE_LAST_CATEGORY = "prv_cat";
